exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup {\n  width: 30% !important;\n  height: 100% !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/sellingpricelevel-popup/sellingpricelevel-popup.component.css
// module id = ../../../../../src/app/shared/component/sellingpricelevel-popup/sellingpricelevel-popup.component.css
// module chunks = main